// Delay before fetching fresh geo data to avoid blocking LCP
export const GEO_FETCH_DELAY_MS = 2000
